import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, renderSlot as _renderSlot } from "vue";
const _hoisted_1 = { key: 0 };
const _hoisted_2 = {
    key: 1,
    class: "dropdown-prompt"
};
const _hoisted_3 = { class: "dropdown-prompt" };
import _ from "underscore";
import { computed } from "vue";
import { ElDropdown, ElDropdownMenu, ElDropdownItem, ElButton, } from "element-plus";
export default /*#__PURE__*/ _defineComponent({
    __name: 'DropdownSelectorInput',
    props: {
        modelValue: {},
        options: {},
        isSelected: { type: Function, default: (option, value) => {
                if (option.value === "custom" && option.value !== value) {
                    return true;
                }
                return option.value === value;
            } },
        allowDeselection: { type: Boolean, default: false },
        prompt: { default: "" },
        disabled: { type: Boolean, default: false }
    },
    emits: ["update:modelValue"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const selectedOption = computed(() => {
            const selection = _.find(props.options, (option) => {
                return props.isSelected(option, props.modelValue);
            });
            return selection;
        });
        const update = (value) => {
            emit("update:modelValue", value);
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(ElDropdown), {
                trigger: "click",
                "hide-on-click": "",
                disabled: _ctx.disabled,
                "popper-class": "list list--drop-down list--drop-down--modern"
            }, {
                dropdown: _withCtx(() => [
                    _createVNode(_unref(ElDropdownMenu), null, {
                        default: _withCtx(() => [
                            (_ctx.allowDeselection)
                                ? (_openBlock(), _createBlock(_unref(ElDropdownItem), {
                                    key: 0,
                                    onClick: _cache[0] || (_cache[0] = ($event) => (update(null)))
                                }, {
                                    default: _withCtx(() => [
                                        _createElementVNode("a", _hoisted_3, _toDisplayString(_ctx.prompt), 1 /* TEXT */)
                                    ]),
                                    _: 1 /* STABLE */
                                }))
                                : _createCommentVNode("v-if", true),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option) => {
                                return (_openBlock(), _createBlock(_unref(ElDropdownItem), {
                                    key: option.value,
                                    onClick: ($event) => (update(option.value))
                                }, {
                                    default: _withCtx(() => [
                                        _createElementVNode("a", null, _toDisplayString(option.displayName), 1 /* TEXT */)
                                    ]),
                                    _: 2 /* DYNAMIC */
                                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"]));
                            }), 128 /* KEYED_FRAGMENT */)),
                            _renderSlot(_ctx.$slots, "post-options")
                        ]),
                        _: 3 /* FORWARDED */
                    })
                ]),
                default: _withCtx(() => [
                    _createVNode(_unref(ElButton), { class: "button button--tertiary button--drop-down list--drop-down--modern" }, {
                        default: _withCtx(() => [
                            (selectedOption.value)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(selectedOption.value.displayName), 1 /* TEXT */))
                                : (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.prompt), 1 /* TEXT */))
                        ]),
                        _: 1 /* STABLE */
                    })
                ]),
                _: 3 /* FORWARDED */
            }, 8 /* PROPS */, ["disabled"]));
        };
    }
});
